var React = require('react');

function ThumbsUpSolid (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.5","y":"0.487793","width":"36","height":"36","rx":"18","fill":"#C7DEBC","key":0}),React.createElement("path",{"d":"M19.449 9.23966L13.909 14.7797C13.539 15.1497 13.329 15.6597 13.329 16.1897V26.1797C13.329 27.2797 14.229 28.1797 15.329 28.1797H24.329C25.129 28.1797 25.849 27.6997 26.169 26.9697L29.429 19.3597C30.269 17.3797 28.819 15.1797 26.669 15.1797H21.019L21.969 10.5997C22.069 10.0997 21.919 9.58966 21.559 9.22966C20.969 8.64966 20.029 8.64966 19.449 9.23966ZM9.32901 28.1797C10.429 28.1797 11.329 27.2797 11.329 26.1797V18.1797C11.329 17.0797 10.429 16.1797 9.32901 16.1797C8.22901 16.1797 7.32901 17.0797 7.32901 18.1797V26.1797C7.32901 27.2797 8.22901 28.1797 9.32901 28.1797Z","fill":"#378151","key":1})]);
}

ThumbsUpSolid.defaultProps = {"width":"37","height":"37","viewBox":"0 0 37 37","fill":"none"};

module.exports = ThumbsUpSolid;

ThumbsUpSolid.default = ThumbsUpSolid;
